let t = null;
let localeRef = null;

export function setTranslator(translatorFn, locale) {
  t = translatorFn;
  localeRef = locale;
}

export function $t(...args) {
  if (!t) throw new Error('Translator not set. Call setTranslator() in main.js');
  return t(...args);
}

export function $locale() {
  return typeof localeRef?.value !== 'undefined' ? localeRef.value : localeRef;
}
